(function () {
  var tabs = document.querySelector('[data-faq-tabs]');
  var list = document.querySelector('[data-faq-list]');
  var search = document.querySelector('[data-faq-search]');
  var empty = document.querySelector('[data-faq-empty]');
  if (!tabs || !list) return;

  var activeCat = 'Tout';
  var term = '';

  function render() {
    var items = list.querySelectorAll('.faq-item');
    var visibleCount = 0;
    items.forEach(function (item) {
      var matchesCat = activeCat === 'Tout' || item.dataset.cat === activeCat;
      var matchesSearch =
        !term ||
        item.dataset.q.toLowerCase().indexOf(term) !== -1 ||
        item.dataset.a.toLowerCase().indexOf(term) !== -1;
      var show = matchesCat && matchesSearch;
      item.hidden = !show;
      if (show) visibleCount++;
    });
    if (empty) empty.hidden = visibleCount !== 0;
  }

  tabs.querySelectorAll('.tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      activeCat = tab.dataset.cat;
      tabs.querySelectorAll('.tab').forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');
      render();
    });
  });

  if (search) {
    search.addEventListener('input', function (e) {
      term = e.target.value.toLowerCase().trim();
      render();
    });
  }

  list.querySelectorAll('[data-faq-q]').forEach(function (q) {
    q.addEventListener('click', function () {
      q.closest('.faq-item').classList.toggle('open');
    });
  });

  render();
})();
